import Actions from '../actions/actions';
import { personasCRUDActions } from '../actions/PersonasCRUDActions';
import { PersonaModel } from '../model/PersonaModel';
import {
  retrieved,
  retrievedAll,
  setBusy,
  setUnBusy,
} from './common/commonReducers';

export type PersonasState = {
  busy: boolean;
  entities: PersonaModel[];
};

const initialState = {
  busy: false,
  entities: [],
};

type ActionType = {
  type: string;
  entities?: PersonaModel[];
  entity?: PersonaModel;
};

export const personas = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case personasCRUDActions.busyAction:
      return setBusy(state);
    case personasCRUDActions.retrievedAction:
      return retrieved(state, action);
    case personasCRUDActions.retrievedAllAction:
      return retrievedAll(state, action);
    case Actions.RESET:
    case personasCRUDActions.resetAction:
      return initialState;
    case Actions.UNBUSY:
    case personasCRUDActions.unbusyAction:
      return setUnBusy(state);
    default:
      return state;
  }
};
